import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { AccountSurveyPayload, SurveyQuestion, SurveyAnwser, AccountSurveyType } from '@dev/ee-api/ee-api-models';
import i18n from '@/../i18n';
import {
    LoadOnboardingSurveyError,
    LoadOnboardingSurveySuccess,
    SaveOnboardingSurveyError,
    SaveOnboardingSurveySuccess,
} from '@/store/onboardingSurvey/actions';
import {
    LoadOnboardingSurveyStartAction,
    OnboardingSurveyActionTypes,
    SaveOnboardingSurveyStartAction,
} from '@/store/onboardingSurvey/types';
import { saveOnboardingSurvey, loadSurvey } from '@/services/ElasticApi';
import { ShowToast } from '@/store/toast/actions';
import { Logger } from '@/services/errors/appLogger';

function* saveSurveyOnboarding({ payload: data }: SaveOnboardingSurveyStartAction): any {
    try {
        const payload: AccountSurveyPayload = {
            FormID: data.formId,
            Type: AccountSurveyType.Onboarding,
            SurveyQuestions: data.responses.map(
                (response): SurveyQuestion => ({
                    QuestionKey: response.questionId,
                    QuestionTranslation: response.questionTitle,
                    Anwsers: response.answers.map(
                        (answer): SurveyAnwser => ({
                            AnwserKey: answer.id,
                            AnwserTranslation: answer.title,
                            Value: answer.value,
                            CustomValue: answer.userValue,
                        })
                    ),
                })
            ),
        };
        yield call(saveOnboardingSurvey, payload);
        yield put(SaveOnboardingSurveySuccess());
    } catch (e) {
        yield put(SaveOnboardingSurveyError());
        yield put(
            ShowToast({
                message: i18n.t('onboardingsurveyerror'),
                severity: 'error',
                duration: 6000,
            })
        );
        Logger.error(e);
    }
}

function* loadSurveySaga({ payload }: LoadOnboardingSurveyStartAction): any {
    const { type = AccountSurveyType.Onboarding } = payload || {};
    try {
        const response = yield call(loadSurvey, type);
        if (response.status !== 200) {
            throw new Error(i18n.t('apitimeout'));
        }
        yield put(LoadOnboardingSurveySuccess(response.data));
    } catch (e) {
        yield put(LoadOnboardingSurveyError());
        // yield put(
        //     ShowToast({
        //         message: i18n.t('onboardingsurveyloaderror'),
        //         severity: 'error',
        //         duration: 6000,
        //     })
        // );
        // Logger.error(e);
    }
}

function* onboardingSurveyWatcher(): any {
    yield takeLatest(OnboardingSurveyActionTypes.SAVE_ONBOARDING_SURVEY_START, saveSurveyOnboarding);
}

function* loadOnboardingSurveyWatcher(): any {
    yield takeLatest(OnboardingSurveyActionTypes.LOAD_ONBOARDING_SURVEY_START, loadSurveySaga);
}

const onboardingSurveySagas = [fork(onboardingSurveyWatcher), fork(loadOnboardingSurveyWatcher)];

export default onboardingSurveySagas;
